/* oxlint-disable tailwindcss/no-unknown-classes -- Styles are colocated in home-new.css. */
// Imported first so these rules come before the trail components’ own CSS.
import "./home-new.css"
import { SiteRebellionSignup } from "../site/SiteRebellionSignup"
import { HomeNewEdgeFades } from "./HomeNewEdgeFades"
import { HomeNewFeaturesSection } from "./HomeNewFeaturesSection"
import { HomeNewHero } from "./HomeNewHero"
import { HomeNewProblemSection } from "./HomeNewProblemSection"

function HomeNewSections() {
  return (
    <>
      <HomeNewHero />
      <HomeNewProblemSection />
      <HomeNewFeaturesSection />
      <SiteRebellionSignup />
    </>
  )
}

export function HomeNewPage() {
  return (
    <div className="home-new bg-base">
      <HomeNewSections />
      <HomeNewEdgeFades />
    </div>
  )
}
